import { FaroStep } from "@faro-lotv/flat-ui";
import { useMemo, type JSX } from "react";
import { AlignmentStepper } from "../alignment-modes-commons/alignment-stepper";

interface SheetToSheetProgressBarProps {
  /** A callback that is called when the user wants to apply the alignment */
  apply(): void;
}

/**
 * This defines all the steps to align sheet to sheet
 */
enum SheetToSheetAlignmentStep {
  alignSheet = "alignSheet",
}

/**
 * @returns The bar that is shown in the top of a sheet-to-sheet alignment mode
 *  Allows user to see where there are currently in the alignment process, and switch between those steps
 */
export function SheetToSheetAlignmentProgressBar({
  apply,
}: SheetToSheetProgressBarProps): JSX.Element {
  /** defines steps for SheetToSheet Alignment progressBar */
  const steps: FaroStep[] = useMemo(
    () => [
      {
        key: SheetToSheetAlignmentStep.alignSheet,
        label: "Align",
      },

      // TODO: Add onBeforeNext when second step will be implemented
    ],
    [],
  );

  return (
    <AlignmentStepper
      steps={steps}
      lastStepButtonText="Confirm Alignment"
      hideStepNumbers
      onLastStepButtonClicked={apply}
    />
  );
}
